//header desktop

var dropdownContent = document.querySelector(".dropdown-content");
var tablinks = document.getElementsByClassName("tablinks");
var tabitems = document.getElementsByClassName("tabitems");
var tabcontent = document.getElementsByClassName("tab-content");
var tab = document.getElementsByClassName("tab");

function openMenu(evt) {
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
  }
  for (let i = 0; i < tabitems.length; i++) {
    tabitems[i].classList.remove("active");
  }
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.opacity = "0";
  }
  for (let i = 0; i < tab.length; i++) {
    tab[i].classList.remove("active");
    tab[i].style.opacity = "0";
  }
  tablinks[0].classList.add("active");
  tabitems[0].classList.add("active");
  tabcontent[0].style.opacity = "1";
  tab[0].style.opacity = "1";
  tabcontent[0].style.display = "block";
  tab[0].style.display = "block";
}

function openTab(evt, tabName) {
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.opacity = "0";
    tabcontent[i].style.display = "none";
  }

  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
  }

  let selectedTab = document.getElementById(tabName);
  if (selectedTab) {
    selectedTab.style.opacity = "1";
    selectedTab.style.display = "block";
    evt.currentTarget.classList.add("active");
  }

  for (let i = 0; i < tabitems.length; i++) {
    tabitems[i].classList.remove("active");
  }

  for (let i = 0; i < tab.length; i++) {
    tab[i].classList.remove("active");
    tab[i].style.opacity = "0";
    tab[i].style.display = "none";
  }

  var element = document.querySelector("." + tabName);
  if (element.classList.contains("active")) {
    var xd = document.querySelector("#" + tabName);
    xd.children[0].classList.add("active");
    let dataSubValue = xd.children[0].getAttribute("data-sub");
    var qw = document.querySelector("#" + dataSubValue);
    qw.style.opacity = "1";
    qw.style.display = "block";
  }
}

function openSubTab(evt, tabName) {
  for (let i = 0; i < tab.length; i++) {
    tab[i].style.opacity = "0";
    tab[i].style.display = "none";
  }

  for (let i = 0; i < tabitems.length; i++) {
    tabitems[i].classList.remove("active");
  }

  let selectedTab = document.getElementById(tabName);
  if (selectedTab) {
    selectedTab.style.opacity = "1";
    selectedTab.style.display = "block";
    evt.currentTarget.classList.add("active");
    let dataMainParentValue = selectedTab.getAttribute("data-main-parent");
    if (dataMainParentValue) {
      var element = document.querySelector("." + dataMainParentValue);
      element.classList.add("active");
    }
  }
}

// header sidebar
document.addEventListener("DOMContentLoaded", function () {
  var subMenus = document.querySelectorAll(".nav__sub");
  subMenus.forEach(function (subMenu) {
    var backButton = document.createElement("li");
    backButton.className = "nav__item";
    backButton.innerHTML =
      '<a class="nav__link sub__close" href="#"><svg aria-hidden="true" focusable="false" fill="none" width="12" class="icon" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"/></svg> Back</a>';
    subMenu.insertBefore(backButton, subMenu.firstChild);
  });

  var closeButtons = document.querySelectorAll(".sub__close");
  closeButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      this.parentElement.parentElement.classList.remove("is-active");
    });
  });

  var links = document.querySelectorAll(".nav__link");
  links.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      var subMenu = this.nextElementSibling;
      if (subMenu) {
        subMenu.classList.add("is-active");
      }
    });
  });
});

//back_top button
const btn = document.querySelector("#back_top_button");

window.addEventListener("scroll", function () {
  if (window.scrollY > 300) {
    btn.classList.add("show");
  } else {
    btn.classList.remove("show");
  }
});

btn.addEventListener("click", function (e) {
  e.preventDefault();
  window.scrollTo({ top: 0, behavior: "smooth" });
});



function ctmItemClickCall(value) {
  const correspondingCheckbox = document.querySelector(
    `.facets-sidebar .cate-list .checkbox-control input[value="${value}"]`
  );
  correspondingCheckbox.click();
}
function cateClickCall(value) {
  const correspondingCheckbox = document.querySelector(
    `.facets-sidebar .cate-list .checkbox-control input[value="${value}"]`
  );
  correspondingCheckbox.click();
}
